/**
 * /app/$tenantSlug/referrals — Employee referral portal (Wave K1.4).
 *
 * The ONE hiring surface every employee gets (any role; hiring
 * feature-gated): open roles with "Refer someone" + "My referrals" with
 * COARSE status only. Deliberately NOT under the HR-admin Hiring
 * module shell — a plain employee never sees the recruiting pipeline,
 * and the backend serves only the minimal/coarse projections here.
 */

import { createFileRoute } from "@tanstack/react-router";
import { MeModuleShell } from "@/components/shared/me-module-shell";
import { HiringFeatureGate } from "@/components/hiring/hiring-feature-gate";
import { ReferralsEmployee } from "@/components/hiring/referrals-employee";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/referrals")({
  component: ReferralsRoute,
});

function ReferralsRoute() {
  return (
    <MeModuleShell
      title="Referrals"
      description="Refer great people for open roles and track your referrals — bonuses land in your payroll automatically."
    >
      <HiringFeatureGate>
        <ReferralsEmployee />
      </HiringFeatureGate>
    </MeModuleShell>
  );
}
